import { useNavigate } from "react-router-dom";

// Props Validations
import PropTypes from "prop-types";

// mui components & icons
import Tooltip from "@mui/material/Tooltip";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// components
import Header from "../components/common/Header";
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import ReportCreationView from "../components/autoDeckReport/ReportCreationView";
import ReportGenerationView from "../components/autoDeckReport/ReportGenerationView";

// assets
import reportCreationIcon from "../assets/icons/auto-deck-report-creation.png";
import reportGenerationIcon from "../assets/icons/auto-deck-report-generation.png";

// redux
import { useDispatch, useSelector } from "react-redux";
import { loadSelectedTabState, loadCriteriaSelectionViewState, loadNavigatedFromStudiesState } from "../store/features/autoDeckReportSlice";

function AutoDeckReport({ headerTitle = "" }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // redux states
    const selectedTab = useSelector((state) => state.autoDeckReportStore.selectedTab);
    const criteriaSelectionView = useSelector((state) => state.autoDeckReportStore.criteriaSelectionView);
    const navigatedFromStudies = useSelector((state) => state.autoDeckReportStore.navigatedFromStudies);

    const handleChange = (event, newValue) => {
        if (newValue) {
            dispatch(loadSelectedTabState(newValue));
        }
    };

    const handleNaviagation = () => {
        if (selectedTab === "creation") {
            criteriaSelectionView ? dispatch(loadCriteriaSelectionViewState(false)) : navigate(-1);
        } else {
            navigate(-1);
            dispatch(loadNavigatedFromStudiesState(false));
            dispatch(loadSelectedTabState("creation"));
        }
    };

    return (
        <>
            <Header
                title={headerTitle}
                isStudySelected={Boolean(selectedTab === "creation")}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>
            <div
                style={{
                    minHeight: "calc(100vh - 160px)",
                    padding: "20px",
                    margin: "20px",
                    marginTop: "35px",
                }}
                className="full-container m-4 background-color-white  box-shadow--full-container"
            >
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                    }}
                >
                    <div
                        className="p-2 liner-light-blue-background color-white"
                        style={{
                            borderRadius: "50%",
                            position: "relative",
                            top: -35,
                            left: -35,
                            cursor: "pointer",
                            zIndex: 10,
                        }}
                        onClick={() => handleNaviagation()}
                    >
                        <span>
                            <ArrowBackIcon className="color-white" />
                        </span>
                    </div>
                </div>

                <div
                    style={{
                        paddingLeft: "20px",
                        marginBottom: "12px",
                    }}
                >
                    <ToggleButtonGroup
                        color="primary"
                        value={selectedTab}
                        exclusive
                        onChange={handleChange}
                        aria-label="Platform"
                        size="small"
                    >
                        <ToggleButton
                            value="creation"
                            disabled={navigatedFromStudies}
                        >
                            <Tooltip
                                title="Report Creation"
                                placement="top"
                            >
                                <img
                                    src={reportCreationIcon}
                                    alt="Report Creation Icon"
                                    style={{
                                        width: "22px",
                                        height: "22px",
                                        cursor: "pointer",
                                        filter: selectedTab && selectedTab !== "creation" ? "grayscale(100%)" : "",
                                        opacity: navigatedFromStudies ? 0.5 : 1
                                    }}
                                />
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton value="generation">
                            <Tooltip
                                title="Report Generation"
                                placement="top"
                            >
                                <img
                                    src={reportGenerationIcon}
                                    alt="Report Generation Icon"
                                    style={{
                                        width: "22px",
                                        height: "22px",
                                        cursor: "pointer",
                                        filter: selectedTab && selectedTab !== "generation" ? "grayscale(100%)" : "",
                                    }}
                                />
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                {selectedTab === "creation" ? <ReportCreationView /> : <ReportGenerationView />}
            </div>
        </>
    );
}

// Typechecking props for the AutoDeckReport
AutoDeckReport.propTypes = {
    headerTitle: PropTypes.string,
};

export default AutoDeckReport;
